import { SuperText } from '../styles';

export const SuperTextElement = ({ text, dataTest }: { text: string; dataTest: string }) => {
  return (
    <SuperText data-test={dataTest} tag="p" type="lead">
      {text}
    </SuperText>
  );
};
